import { goRequest } from '../utils/httpClientTs';

export interface Country {
  id: string;
  name: string;
  has_states: boolean;
}

export interface State {
  id: string;
  name: string;
  abbreviation: string;
  country_id: string;
}

export interface PostalInfo {
  city: string;
  state_id: string;
  state: string;
  country_id: string;
  country: string;
}

export const getCountries = (): Promise<Country[]> => {
  return goRequest<Country[]>({
    url: '/membership/countries',
    method: 'GET',
  });
};

export const getStates = (countryId?: string): Promise<State[]> => {
  let url = '/membership/states';
  if (countryId) {
    url += `?country=${countryId}`;
  }
  return goRequest<State[]>({
    url: url,
    method: 'GET',
  });
};

export const getPostalInfo = (
  postalCode: string,
  countryId: string
): Promise<PostalInfo> => {
  let url = '/membership/postal_info';
  const searchParams = new URLSearchParams();

  if (countryId) {
    searchParams.append('country', countryId);
  }
  if (postalCode) {
    searchParams.append('postal_code', postalCode);
  }

  if (searchParams.toString()) {
    url += `?${searchParams.toString()}`;
  }

  return goRequest<PostalInfo>({
    url: url,
    method: 'GET',
  });
};
